import React from 'react';
import { ImageProps } from '.';

const SvgProfileKakao = ({ size = 24, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 1)) || 24} fill='none' viewBox='0 0 24 24' {...props}>
      <circle cx={12} cy={12} r={12} fill='#FFCD00' />
      <path
        fill='#000'
        d='m11.552 12.675 3.78 4.562 1.108-.848-3.201-3.79 2.764-3.422-1.125-.801-3.326 4.3ZM9.6 5.108V17.02h1.436V4.8L9.6 5.108Z'
      />
    </svg>
  );
};

export default SvgProfileKakao;
